import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function unit(params: any): any {
    const { search, limit, pages } = params.data
    return api.get(`${URL.UNIT_GET}?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}

function createUnit(params: any): any {
    const { data } = params
    return api.create(URL.UNIT_POST, data);
}
function updateUnit(params: any): any {
    const { data } = params
    return api.update(URL.UNIT_UPDATE, data);
}
function deleteUnit(params: any): any {
    const { data } = params;
    return api.delete(`${URL.UNIT_DELETE}?_id=${data?.id}`);
}
function uploadUnit(params: any): any {
    const { data } = params;
    return api.create(URL.UNIT_UPLOAD, data);
}

export { unit, createUnit, updateUnit, deleteUnit, uploadUnit }